export default __webpack_public_path__ + "static/media/left-arrow.e7b0ec78.svg";